import React from 'react';
import { formatMoney } from '../marketing/shared';

// Small pieces shared by the Commissions pages.

// The IRS Logics page for a case, so a case number in any grid opens it.
export const logicsCaseUrl = (caseNumber) =>
    `https://taxtitans.logics.com/Cases/Case.aspx?CaseID=${encodeURIComponent(caseNumber)}`;

export function CaseLink({ value, node }) {
    if (!value || (node && node.rowPinned)) return value || '';
    return (
        <a href={logicsCaseUrl(value)} target="_blank" rel="noopener noreferrer">{value}</a>
    );
}

export const caseColumn = (field = 'case_number') => ({
    field,
    headerName: 'Case #',
    width: 110,
    cellRenderer: CaseLink,
});

export const formatPct = (value) =>
    value == null || value === '' ? '' : `${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;

// Payment times are the Logics report's wall-clock time with no zone. The
// server sends them as "2026-09-01T10:15:00Z"; read the digits as written so
// the browser's timezone never moves a payment to another day.
export function formatPaidAt(value) {
    if (!value) return '';
    const [date, time = ''] = String(value).split('T');
    const [y, m, d] = date.split('-');
    const hhmm = time.slice(0, 5);
    const showTime = hhmm && hhmm !== '00:00';
    return `${m}/${d}/${y}${showTime ? ` ${hhmm}` : ''}`;
}

// A YYYY-MM-DD date (an opener's last day) as MM/DD/YYYY, read as written so
// the browser's timezone can't move it.
export function formatDay(iso) {
    if (!iso) return '';
    const [y, m, d] = String(iso).split('-');
    return y && m && d ? `${m}/${d}/${y}` : String(iso);
}

// How an opener's status reads: on the team, leaving on a set day, or gone.
export function openerStatus(active, endDate) {
    if (!endDate) return 'Active';
    return active ? `Leaving ${formatDay(endDate)}` : `Inactive (last day ${formatDay(endDate)})`;
}

// A split's ceilings, as the form shows them while typing: the opener's
// commissionable (split % of the case amount) and their commission (rate %
// of that). Rounded the way the server rounds: once, to the cent.
export function splitCaps(splitPct, ratePct, amount) {
    const p = Number(splitPct);
    const r = Number(ratePct);
    const cents = Math.round(Number(amount) * 100);
    if (!(p > 0) || !(r > 0) || !(cents > 0)) return null;
    return {
        commissionable: Math.round((cents * p) / 100) / 100,
        commission: Math.round((cents * p * r) / 10000) / 100,
    };
}

export const moneyOrDash = (value) => (value == null ? '—' : formatMoney(value));
